import request from '@/router/axios'

export const getList = (params) => request({
  url: '/api/produce/env-monitor/pull-log/selectPage',
  method: 'post',
  data: params
})
